import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ModalDirective} from "ngx-bootstrap/modal";

@Component({
    selector: 'cb-modal-confirm',
    templateUrl: 'confirm.component.html'
})
export class ConfirmComponent {
    @Output() onConfirm = new EventEmitter();
    @Input()  title: string = "";
    @Input()  content: string = "";
    @Input()  confirmButton: string = "保存";
    @Input()  closeButton: string = "閉じる";
    @Input()  modalClass: string = "";
    @ViewChild('modal') public modal:ModalDirective;

    confirm(){
        this.onConfirm.emit();
        this.modal.hide();
    }

    show(){
        this.modal.show();
    }
}
